module.exports = __webpack_public_path__ + "img/oeuf.288c904d.svg";